import { useMemo } from 'react';

import round from 'lodash/round';
import { bytesToUnit } from '@cast/utils';

import { notReachable } from 'utils/types/not-reachable';

import { WorkloadBaseRunningInNode } from '../types';

import { Typography, Stack } from '@cast/design-system';

type Props = {
  workload: WorkloadBaseRunningInNode;
  resource: 'cpu' | 'memory';
};

export const WorkloadResourceRequestCell = ({ workload, resource }: Props) => {
  const { amount, unit, sortWeight } = useMemo(() => {
    switch (resource) {
      case 'cpu':
        return {
          amount: round(workload.resourcesPerNode.requested.milliCpu / 1000, 2),
          unit: 'CPU',
          sortWeight: workload.resourcesPerNode.requested.milliCpu,
        };
      case 'memory': {
        const [amount, unit] = bytesToUnit(
          workload.resourcesPerNode.requested.memoryBytes
        );
        return {
          amount,
          unit,
          sortWeight: workload.resourcesPerNode.requested.memoryBytes,
        };
      }
      default:
        return notReachable(resource);
    }
  }, [workload, resource]);

  if (!amount) {
    return <span data-sortweight="0">-</span>;
  }

  return (
    <Stack direction="row" alignItems="baseline" gap="4px">
      <Typography variant="inherit" data-sortweight={sortWeight}>
        {amount}
      </Typography>
      <Typography variant="P12R" color="textSecondary">
        {unit}
      </Typography>
    </Stack>
  );
};
